import { LandingLogo } from '@/components/LandingLogo';
import { createFileRoute } from '@tanstack/react-router'
import { useBrandConfigStore } from "@/hooks/brandConfigStore";

export const Route = createFileRoute('/(welcome-gift)/welcome-gift/error')({
    component: RouteComponent,
})

function RouteComponent() {
    const { config } = useBrandConfigStore();

    return (
        <div
            className="flex flex-col w-full h-full justify-center"
            style={config ? { fontFamily: config.fonts.mainFont } : undefined}
        >
            <div
                className="flex flex-col items-center text-white bg-[#D25432] pb-12 h-[95%] sm:h-[80%] px-6"
                style={config ? { backgroundColor: config.bgColors.mainColor } : undefined}
            >
                {config ? (
                    <img src={config.logoUrl} alt="Logo" style={config.logoStyle} />
                ) : (
                    <LandingLogo fill="#FFFFFF" width="150px" />
                )}
                <div className="-rotate-15 mt-26 sm:mt-32">
                    <p
                        className="text-[3.2rem] text-white font-bold text-center font-frushand"
                        style={config ? { fontFamily: config.fonts.titleFont } : undefined}
                    >
                        OOPS, SORRY
                    </p>
                </div>
                <div className="mt-auto">
                    <p className="text-2xl font-bold text-center">the welcome gift is limited <br />to one per guest, and <br />it has already been redeemed</p>
                </div>
            </div>
        </div>
    );
}
